import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        try {
            const raw = localStorage.getItem("ccc_user");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    });
    const [loading, setLoading] = useState(true);

    const validate = useCallback(async () => {
        const token = localStorage.getItem("ccc_token");
        if (!token) {
            setLoading(false);
            return;
        }
        try {
            const res = await api.get("/auth/me");
            setUser(res.data.user);
            localStorage.setItem("ccc_user", JSON.stringify(res.data.user));
        } catch {
            localStorage.removeItem("ccc_token");
            localStorage.removeItem("ccc_user");
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        validate();
        // Re-validate when window regains focus (catches deletion-while-away)
        const onFocus = () => validate();
        window.addEventListener("focus", onFocus);
        return () => window.removeEventListener("focus", onFocus);
    }, [validate]);

    const loginAdmin = async (username, password) => {
        const res = await api.post("/auth/admin/login", { username, password });
        localStorage.setItem("ccc_token", res.data.token);
        localStorage.setItem("ccc_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    const requestOtp = async (email) => {
        await api.post("/auth/parent/request-otp", { email });
    };

    const verifyOtp = async (email, otp) => {
        const res = await api.post("/auth/parent/verify-otp", { email, otp });
        localStorage.setItem("ccc_token", res.data.token);
        localStorage.setItem("ccc_user", JSON.stringify(res.data.user));
        setUser(res.data.user);
        return res.data.user;
    };

    const logout = () => {
        localStorage.removeItem("ccc_token");
        localStorage.removeItem("ccc_user");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, loginAdmin, requestOtp, verifyOtp, logout, validate }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
    return ctx;
};
